import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { mapCertificate } from '../../reducers/certificateReducer';
import { fetchCertificateIfNeeded, fetchCertificate } from '../../actions/certificate';
import EditPanel from './EditPanel';

const Certificate = ({
  loaded,
  dispatch,
  certificateData,
  showErrorMessage,
  errorMessage,
  EmployeeMasterID,
}) =>
  (<EditPanel
    title={<FormattedMessage id="certificate.title" />}
    emptyText="certificate.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchCertificateIfNeeded())}
    modelName="EmployeeMasterCertificate"
    dataSource={certificateData}
    mapModel={mapCertificate}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchCertificate}
  />);

function mapStateToProps(state) {
  return {
    loaded: state.certificateReducer.loaded,
    certificateData: state.certificateReducer.certificateData,
    form: state.form.EmployeeMasterCertificate,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    showErrorMessage: (state.certificateReducer.error && state.certificateReducer.error.Message.length) > 0,
    errorMessage: (state.educationReducer.error && state.educationReducer.error.Message) || '',
  };
}

Certificate.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  certificateData: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
};

export default connect(mapStateToProps)(Certificate);



// WEBPACK FOOTER //
// ./src/components/profile/Certificate.js